if (!customElements.get('bundle-product-form')) {
  customElements.define(
    'bundle-product-form',
    class BundleProductForm extends HTMLElement {
      constructor() {
        super();

        this.submitButtonElement = this.querySelector('[type="submit"]');
        this.submitButtonElement && this.submitButtonElement.addEventListener('click', this.handleSubmit.bind(this));
      }

      get cartDrawerElement() {
        return document.querySelector('cart-drawer');
      }

      get bundleItems() {
        const script = this.querySelector('[data-bundle-items]');
        if (!script) return [];

        try {
          return JSON.parse(script.textContent || '[]');
        } catch (error) {
          console.error('Unable to parse bundle items', error);
          return [];
        }
      }

      handleSubmit(event) {
        event.preventDefault();
        if (!this.submitButtonElement || this.submitButtonElement.disabled) return;

        this.lastSubmittedElement = event.submitter || event.currentTarget;
        this.showErrorMessage();
        this.toggleButtonLoading(true);

        const items = this.buildCartItems();
        if (!items.length) {
          this.showErrorMessage('This bundle is missing its products.');
          this.toggleButtonLoading(false);
          return;
        }

        if (document.body.classList.contains('cart-template') || FoxTheme.settings.cartType === 'page') {
          this.addBundleToCart({ items })
            .then((parsedState) => {
              if (parsedState.status) {
                this.showErrorMessage(parsedState.description);
                return;
              }

              window.location.href = FoxTheme.routes.cart_url;
            })
            .catch((error) => console.error(error))
            .finally(() => this.toggleButtonLoading(false));
          return;
        }

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        this.addBundleToCart({
          items,
          sections: sectionsToBundle,
          sections_url: window.location.pathname,
        })
          .then(async (parsedState) => {
            if (parsedState.status) {
              this.showErrorMessage(parsedState.description);
              document.dispatchEvent(
                new CustomEvent('product-ajax:error', {
                  detail: { errorMessage: parsedState.description },
                })
              );
              return;
            }

            const cartJson = await (
              await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })
            ).json();
            cartJson.sections = parsedState.sections;

            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
            document.dispatchEvent(
              new CustomEvent('product-ajax:added', {
                detail: { product: parsedState },
              })
            );
            this.cartDrawerElement && this.cartDrawerElement.show(this.lastSubmittedElement);
          })
          .catch((error) => console.error(error))
          .finally(() => this.toggleButtonLoading(false));
      }

      addBundleToCart(payload) {
        return fetch(`${FoxTheme.routes.cart_add_url}`, {
          ...FoxTheme.utils.fetchConfig('javascript'),
          body: JSON.stringify(payload),
        }).then((response) => response.json());
      }

      buildCartItems() {
        const bundleId = Date.now();
        const bundleQuantity = Math.max(parseInt(this.dataset.quantity || '1', 10), 1);
        const properties = this.bundleProperties(bundleId);

        return this.bundleItems
          .filter((item) => item && item.id)
          .map((item) => ({
            id: item.id,
            quantity: bundleQuantity,
            properties,
          }));
      }

      bundleProperties(bundleId) {
        const properties = {
          _bundleId: String(bundleId),
          _parent: String(this.dataset.parentVariantId || ''),
        };

        if (this.dataset.bundleDiscount) properties._discount = String(this.dataset.bundleDiscount);
        if (this.dataset.parentImage) properties._image = this.normalizeImage(this.dataset.parentImage);
        if (this.dataset.parentTitle) properties._title = this.dataset.parentTitle;

        return properties;
      }

      normalizeImage(image) {
        return image.replace(/^\/\//, 'https://');
      }

      showErrorMessage(errorMessage = false) {
        this.errorMessageElement = this.errorMessageElement || this.querySelector('.product-form__error-message');
        if (!this.errorMessageElement) {
          errorMessage && alert(errorMessage);
          return;
        }

        this.errorMessageElement.hidden = !errorMessage;
        if (errorMessage) this.errorMessageElement.textContent = errorMessage;
      }

      toggleButtonLoading(status) {
        if (!this.submitButtonElement) return;

        if (status) {
          this.submitButtonElement.classList.add('btn--loading');
          this.submitButtonElement.disabled = true;
        } else {
          this.submitButtonElement.classList.remove('btn--loading');
          this.submitButtonElement.disabled = false;
        }
      }
    }
  );
}
